import Interior from './components/interior'
import Exterior from './components/exterior'
import { VIRTUAL_TOUR_TABS } from './constant'
import './styles.scss'
import close from '../../assets/close.svg'

function ActiveTab({ tab, config, setTab }) {
  switch (tab) {
    case VIRTUAL_TOUR_TABS.EXTERIOR:
      return (
        <Exterior
          slides={config?.exteriorSlides}
          onTabChange={setTab}
        />
      )
    case VIRTUAL_TOUR_TABS.INTERIOR:
    default:
      return (
        <Interior
          slides={config?.interiorSlides}
          onTabChange={setTab}
        />
      )
  }
}

function VirtualTour({ config, className, onClose, tab, setTab }) {
  return (
    <div className={`${className || ''} virtual-tour`}>
      <button
        className="virtual-tour__close-btn"
        onClick={onClose}
      >
        <img
          src={close}
          alt="Close"
        />
      </button>
      <div className="virtual-tour__tab">
        <ActiveTab
          config={config}
          tab={tab}
          setTab={setTab}
        />
      </div>
    </div>
  )
}

export default VirtualTour
